export default "__VITE_ASSET__x8lZ8A6h__"